import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Sujet } from '../sujet';
import { GestionSujetsService } from '../gestion-sujets.service';

@Component({
  selector: 'app-add-new-sujet',
  templateUrl: './add-new-sujet.component.html',
  styleUrls: ['./add-new-sujet.component.css']
})
export class AddNewSujetComponent implements OnInit {

  private message: string;
  private messageClass: string;
  private formGroupeAddNew: FormGroup;

  constructor(
    private addNewService: GestionSujetsService,
    private formBuilder: FormBuilder
  ) {
      this.createFormGroupeAddNew();
  }

  private createFormGroupeAddNew(): void {
        this.formGroupeAddNew = this.formBuilder.group({
            titre: ['', Validators.compose([
                Validators.required,
                Validators.maxLength(100)
              ]
            )],
            description: ['', Validators.compose([
                Validators.maxLength(600)
              ]
            )],
            date_Creation: [Date, Validators.compose([
                Validators.required
              ]
            )]
        });
  }

  private onAddNewSubmit(): void {
    const newSujet: Sujet = {
        titre: this.formGroupeAddNew.get('titre').value,
        description: this.formGroupeAddNew.get('description').value,
        date_Creation: this.formGroupeAddNew.get('date_Creation').value
    };
    this.addNewService.addNewSujet(newSujet).subscribe( data => {
            if (!data.success) {
                this.messageClass = 'alert alert-danger';
                // this.message = 'ERREUR: ' + newEntreprise.raisonSocial + ' n\'est pas sauvegardé!';
                this.message = data.message;
              }else {
                this.disableForm();
                this.messageClass = 'alert alert-success';
                this.message = data.message;
                setTimeout(() => {
                    this.enableForm();
                    this.resetForm();
                    this.messageClass = '';
                    this.message = '';
                }, 3000);
              }
    });
  }

  private disableForm(): void {
    this.formGroupeAddNew.controls['titre'].disable();
    this.formGroupeAddNew.controls['description'].disable();
    this.formGroupeAddNew.controls['date_Creation'].disable();
  }

  private enableForm(): void {
    this.formGroupeAddNew.controls['titre'].enable();
    this.formGroupeAddNew.controls['description'].enable();
    this.formGroupeAddNew.controls['date_Creation'].enable();
  }

  private resetForm(): void {
    this.formGroupeAddNew.controls['titre'].reset();
    this.formGroupeAddNew.controls['description'].reset();
    this.formGroupeAddNew.controls['date_Creation'].reset();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/gestion-sujets/add-new-sujet/add-new-sujet.component.ts